module.exports = __webpack_public_path__ + "img/7877EE_D87FC5_75D9C7_1C78C0-256px.300bd2c6.png";